import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsBikeNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M8 9h10v3h-3.063l1.417 3.007c.048-.005.097-.007.146-.007h13.783l-1.663-3.913A1.5 1.5 0 0130 9h9.5a4.5 4.5 0 110 9H38v-3h1.5a1.5 1.5 0 000-3h-7.233l3.943 9.278a9.5 9.5 0 11-2.76 1.174l-1.44-3.386-8.79 12.306A1.5 1.5 0 0122 32h-3.118c-.719 4.534-4.646 8-9.382 8a9.5 9.5 0 010-19c.995 0 1.954.153 2.855.436l1.911-3.823L11.62 12H8zm7.894 12.066L11.927 29h7.707zm6.372 6.48L29.086 18h-11.32zM9.5 24a6.5 6.5 0 106.326 8H9.5a1.5 1.5 0 01-1.342-2.17l2.83-5.659A6.516 6.516 0 009.5 24zm25.145 1.266a6.5 6.5 0 102.76-1.174l3.062 7.202-2.76 1.173z"
        fill=""
      />
    </svg>
  )
);
SvgSportsBikeNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsBikeNormalLarge;
